import { render } from "./SensorWaterLeak.vue?vue&type=template&id=497745d3"
import script from "./SensorWaterLeak.vue?vue&type=script&lang=js"
export * from "./SensorWaterLeak.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__